import { Alert, Box, Button, Link, TextField } from "@mui/material";
import { useAsyncAction } from "nate-react-api-helpers";
import { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { api } from "../../api/API";
import { useUrlState } from "../../misc/urlParams";
import { AccountCard, emailInputProps } from "./AccountCard";
import { InviteEmail } from "./InviteEmail";

export function RegisterPage() {
    const url = useUrlState();
    const invite = url.text("invite");

    const [email, setEmail] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [password, setPassword] = useState("");
    const [sent, setSent] = useState(false);

    const register = useAsyncAction(async (input: {
        email: string; password: string; firstName: string; lastName: string; inviteToken?: string;
    }) => {
        await api.account.register(input);
        setSent(true);
    }, []);

    if (sent) {
        return (
            <AccountCard title="Check your email">
                <Alert severity="success">
                    We sent a link to {email}. Open it to confirm your email and start using tsk.
                </Alert>
            </AccountCard>
        );
    }

    return (
        <AccountCard title="Create an account">
            {/* an invite is for one address, so the field is locked to it */}
            {invite && <InviteEmail token={invite} onEmail={setEmail} />}

            <form onSubmit={e => {
                e.preventDefault();
                register.callback({
                    email: email,
                    password: password,
                    firstName: firstName,
                    lastName: lastName,
                    inviteToken: invite || undefined,
                });
            }}>
                <TextField label="Email" autoComplete="email" fullWidth slotProps={emailInputProps}
                           disabled={!!invite}
                           value={email} onChange={e => setEmail(e.target.value)} />
                <div style={{ height: 8 }} />
                <Box sx={{ display: "flex", gap: 1 }}>
                    <TextField label="First name" autoComplete="given-name" fullWidth
                               value={firstName} onChange={e => setFirstName(e.target.value)} />
                    <TextField label="Last name" autoComplete="family-name" fullWidth
                               value={lastName} onChange={e => setLastName(e.target.value)} />
                </Box>
                <div style={{ height: 8 }} />
                <TextField label="Password" type="password" autoComplete="new-password" fullWidth
                           helperText="At least 8 characters"
                           value={password} onChange={e => setPassword(e.target.value)} />
                <div style={{ height: 16 }} />
                <Button type="submit" variant="contained" fullWidth disabled={register.loading}>
                    Create account
                </Button>
                {register.LoadingElement}
            </form>

            <Box sx={{ pt: 2, textAlign: "center" }}>
                <Link component={RouterLink} to="/login" variant="body2">I have an account</Link>
            </Box>
        </AccountCard>
    );
}
